import PropTypes from 'prop-types';

const PageProp = PropTypes.shape({
  api: PropTypes.shape({
    method: PropTypes.string,
  }),
  filename: PropTypes.string,
  operationId: PropTypes.string,
  path: PropTypes.string,
  title: PropTypes.string,
});

const ApiEndpointProp = PropTypes.shape({
  category: PropTypes.string,
  children: PropTypes.arrayOf(PageProp),
  title: PropTypes.string,
});

export { ApiEndpointProp };
